export const TableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: "Organismo",
          type: "custom-html",
          key: "business_name",
          modifier: (item) => {
            return item;
          },
        },
      ],
      actionObj: {
        title: "Acciones",
        type: "action",
      },
    };
  },
};
